import {Component, Inject}                 from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef}     from '@angular/material/dialog';

export interface DialogData
{
    title: string,
    message: string,
    type: 'confirm' | 'danger' | 'danger-outline',
    confirmButtonLabel?: string,
    cancelButtonLabel?: string,
    confirmationKeyword?: string,
}

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false,
})
export class DialogComponent
{
    public confirmationKeywordValue: string = '';
    public confirmationKeyword: string | null;

    public constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: DialogData,
        public dialogRef: MatDialogRef<DialogComponent>
    )
    {
        this.confirmationKeyword = this.data.confirmationKeyword?.trim().toLowerCase() || null;
    }

    public get requiresConfirmationKeyword(): boolean
    {
        return !!this.confirmationKeyword;
    }

    public get canConfirm(): boolean
    {
        if (!this.requiresConfirmationKeyword) {
            return true;
        }

        return this.confirmationKeywordValue.trim().toLowerCase() === this.confirmationKeyword;
    }

    public onConfirmationKeywordInput(event: Event): void
    {
        this.confirmationKeywordValue = (event.target as HTMLInputElement).value;
    }
}
